import { render } from "./ClientInvoiceDataSettings.vue?vue&type=template&id=0de6e994"
import script from "./ClientInvoiceDataSettings.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ClientInvoiceDataSettings.vue?vue&type=script&charset=utf-8&lang=js"

import "./ClientInvoiceDataSettings.vue?vue&type=style&index=0&id=0de6e994&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__